import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#032E32",
      d: "M19.5 3h-15A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h10.19a1.487 1.487 0 0 0 1.06-.44l4.81-4.81a1.487 1.487 0 0 0 .44-1.06V4.5A1.5 1.5 0 0 0 19.5 3Zm-15 1.5h15v9.75H15a.75.75 0 0 0-.75.75v4.5H4.5v-15Zm13.94 11.25-2.69 2.69v-2.69h2.69Z"
    }, null, -1)
  ]))]))
}
export default { render: render }